import { defineMessages } from 'react-intl';

export default defineMessages({
  cancel: {
    id: 'saham_drawer.cancel',
  },
  disableReasonsTitle: {
    id: 'timeline_history.drawer.disableReason.title',
  },
});
